import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import SpectralMappingForm from './SpectralMappingForm';
import SpectralCredentialsForm from './SpectralCredentialsForm';

const SpectralConfigListing = (props) => (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={SpectralMappingForm}
        CredentialsForm={SpectralCredentialsForm}
        componentName="Assets"
        componentKey="assetId"
     />
);

export default SpectralConfigListing;
